import { Box, TextField, InputAdornment } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import ReviewActionButtons from './ReviewActionButtons';
import { useTranslation } from 'react-i18next';

interface ReviewToolbarProps {
  searchTerm: string;
  onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onDisapprove: () => void;
  onApprove: () => void;
  onDelete: () => void;
  showApprove?: boolean;
  showDisapprove?: boolean;
  showDelete?: boolean;
  searchPlaceholderKey?: string;
}

const ReviewToolbar: React.FC<ReviewToolbarProps> = ({
  searchTerm,
  onSearchChange,
  onApprove,
  onDisapprove,
  onDelete,
  showApprove = true,
  showDisapprove = true,
  showDelete = true,
  searchPlaceholderKey = 'review.itemReview.searchPlaceholder',
}) => {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        mb: 2,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: 2,
      }}
    >
      <Box
        sx={{
          width: 600,
          border: '1px solid #ccc',
          borderRadius: '8px',
          background: '#fff',
        }}
      >
        <TextField
          placeholder={t(searchPlaceholderKey)}
          size="medium"
          value={searchTerm}
          onChange={onSearchChange}
          sx={{
            '.MuiOutlinedInput-root': { height: 40, border: 'none',width:600 },
            '& fieldset': { border: 'none' },
            '& .MuiInputBase-input': { paddingTop: '10px' },
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon sx={{ fontSize: 20, color: '#aaa', mt: '4px' }} />
              </InputAdornment>
            ),
          }}
        />
      </Box>

      <ReviewActionButtons onApprove={onApprove} onDisapprove={onDisapprove} onDelete={onDelete} showApprove={showApprove} showDisapprove={showDisapprove} showDelete={showDelete} />
    </Box>
  );
};

export default ReviewToolbar;
